import { useState } from 'react';

const KEY = 'tiffin_scan_mode';

// Persists per-device so a shared counter tablet/PC keeps whichever scan method staff last picked —
// used by both the Staff QR Scanner and POS Scanner, and configurable as a default from Admin Settings.
export function useScanMode() {
  const [mode, setModeState] = useState(() => localStorage.getItem(KEY) || 'CAMERA');

  const setMode = (next) => {
    localStorage.setItem(KEY, next);
    setModeState(next);
  };

  return [mode, setMode];
}
